import { Inject, Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { BehaviorSubject, firstValueFrom, Observable, Subject } from 'rxjs';
import * as signalR from '@microsoft/signalr';
import { _isAuthenticated, _isId } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private hubConnection!: signalR.HubConnection;
  private notificationsSubject = new BehaviorSubject<any[]>([]);
  notifications$ = this.notificationsSubject.asObservable();

  constructor(@Inject("backendUrl") private baseurl: string, private httpClientService: HttpClientService) {
    if (_isAuthenticated) {
      this.startConnection(_isId?.toString());
    }
  }

  startConnection(userId: string) {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.baseurl}notificationHub?userId=${userId}`, { transport: signalR.HttpTransportType.WebSockets }) // query param ile gönder
      .withAutomaticReconnect()
      .build();

    this.hubConnection.start()
      .then(() => console.log('SignalR Connected'))
      .catch(err => console.error('Error while starting connection: ' + err));

    this.addNotificationListener();
  }

  // 2.2 Bildirimleri dinle
  private addNotificationListener() {
    this.hubConnection.on('ReceiveNotification', (notification: any) => {
      console.log('New notification:', notification);

      // Mevcut bildirim listesine ekle
      const current = this.notificationsSubject.value;
      this.notificationsSubject.next([notification, ...current]);
    });
  }
  /*
    async personLeaveEndNotification(){
      const observable:Observable<any> = this.httpClientService.get({
        controller:ControllerType.Notification
      });
      return await firstValueFrom(observable);
    }
  */

  async getNotExpiryNotifications() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Notification,
      action: "GetNotExpiryNotifications"
    });
    return await firstValueFrom(observable);
  }

  async getByIdNotification(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Notification,
      action: "GetByIdNotification"
    }, id);
    return await firstValueFrom(observable);
  }

  async getAllNotifications(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Notification,
      queryString: `Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async createNotification(createNotification) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Notification
    }, createNotification);
    return await firstValueFrom(observable);
  }

  async updateNotification(updateNotification) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Notification,
    }, updateNotification);
    return await firstValueFrom(observable);
  }

  async getUserByIdNotification(page,size,userId,notExpiry){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Notification,
      queryString:`page=${page}&size=${size}&userId=${userId}&notExpiry=${notExpiry}`,
      action:"GetUserByIdNotification"
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}